import { render, staticRenderFns } from "./StaffAccounts.vue?vue&type=template&id=965f92ea"
import script from "./StaffAccounts.vue?vue&type=script&lang=js"
export * from "./StaffAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports